import React from "react";

// Modules
import { useEffect, useState } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useNavigate } from "react-router";

// App
import {
  client,
  apiEndpoints,
  serverUrl,
  favoritesEnabled,
  counterEnabled,
} from "../../config";
import { getOnlineNode } from "../../core/getNode";
import Pagination from "../../partials/pagination";
import PageHeader from "../../partials/pageHeader";
import { alertMessages } from "../../partials/alertMessages";
import Error from "../../partials/error";
import NoData from "../../partials/noData";
import {
  getFavoritesByContentType,
  favoritesContentType,
} from "../../utils/helpers";
import GalleryItem from "../galleries/galleryItem";
import ClientTheme from "../../core/clientTheme";
import { patchNode } from "../../core/postNode";
import { PostContextProvider } from "../../contexts/postContext";
import { getEntityCategories } from "../../partials/posts/postHelpers";
import PostItemActions from "../../partials/posts/postItemActions";
import PostDelete from "../../partials/posts/postDelete";
import PostShare from "../../partials/posts/postShare";
import PostPublishing from "../../partials/posts/postPublish";
import PostSetting from "../../partials/posts/postSetting";
import { filterParams } from "../../partials/posts/postHelpers";

// UI components
import Row from "react-bootstrap/Row";
import CompanyappLoader from "../../partials/companyappLoader";

const contentType = favoritesContentType("gallery");
const pageSize = 20;

export default function GalleriesCreator(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorStatus, setErrorStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [categories, setCategories] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [sitas, setSitas] = useState([]);
  const [references, setReferences] = useState([]);
  const [data, setData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const user = useSelector((state) => state).authReducer.user;
  const favorites = useSelector((state) => state).favoritesReducer;
  const counter = useSelector((state) => state).counterReducer;
  const permissions = useSelector((state) => state).permissionsReducer
    .permissions;
  const entityFiltersReducer = useSelector(
    (state) => state.entityFiltersReducer.galleries,
    shallowEqual,
  );
  const favStrings = getFavoritesByContentType(favorites, contentType, true);
  const clientTheme = { ...ClientTheme() };

  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (counterEnabled) {
      updateRemoteCounter();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getContent(1);
    // eslint-disable-next-line
  }, [entityFiltersReducer]);

  useEffect(() => {
    if (categories.length <= 1) {
      getEntityCategories({
        user,
        setCategories,
        setLanguages,
        setSitas,
        setReferences,
        _setError,
        targetVid: "gallery_categories",
      });
    }
    if ((activeIndex === 1 && favStrings !== "") || activeIndex === 0) {
      getContent(1);
    } else {
      setData([]);
      setIsLoading(false);
    }
    // eslint-disable-next-line
  }, [activeIndex, entityFiltersReducer]);

  useEffect(() => {
    if (activeIndex === 1) {
      if (favStrings !== "") {
        getContent(1);
      } else {
        setData([]);
        setIsLoading(false);
      }
    }
    // eslint-disable-next-line
  }, [favStrings]);

  /**
   * @function setError
   * @description Updates the state of the component upon an error
   * @param {boolean} _isError
   * @param {int} _errorStatus
   * @param {string} _errorMessage
   */
  const _setError = (_isError, _errorStatus, _errorMessage) => {
    setIsLoading(false);

    setIsError(_isError);
    setErrorStatus(_errorStatus);
    setErrorMessage(_errorMessage);
  };

  /**
   * @function getContent
   * @description Retrieves the data from an API / Fallback to local realm object if there is no connection
   */
  const getContent = (_currentPage) => {
    setIsLoading(true);
    let path;

    if (client === "companyapp") {
      path = `${apiEndpoints.gallery}?items_per_page=${pageSize}&page=${_currentPage - 1}`;

      if (activeIndex === 1) {
        path = `${apiEndpoints.gallery}?id=${favStrings}&items_per_page=${pageSize}&page=${_currentPage - 1}`;
      }
    }
    // else {
    //   path = `${
    //     apiEndpoints.gallery
    //   }?status=1&promote=1&items_per_page=${pageSize}&page=${_currentPage - 1}`;

    //   const tid = selectedCategory;
    //   if (tid !== 0) {
    //     path = `${
    //       apiEndpoints.gallery
    //     }/${tid}/all?status=1&promote=1&items_per_page=${pageSize}&page=${
    //       _currentPage - 1
    //     }`;
    //   }
    //   if (activeIndex === 1) {
    //     path = `${
    //       apiEndpoints.gallery
    //     }/all/${favStrings}?status=1&promote=1&items_per_page=${pageSize}&page=${
    //       _currentPage - 1
    //     }`;

    //     if (tid !== 0) {
    //       path = `${
    //         apiEndpoints.gallery
    //       }/${tid}/${favStrings}?status=1&promote=1&items_per_page=${pageSize}&page=${
    //         _currentPage - 1
    //       }`;
    //     }
    //   } else {
    //     if (tid !== 0) {
    //       path = `${
    //         apiEndpoints.gallery
    //       }/${tid}/all?status=1&promote=1&items_per_page=${pageSize}&page=${
    //         _currentPage - 1
    //       }`;
    //     }
    //   }
    // }

    path = filterParams(entityFiltersReducer, path);

    getOnlineNode(path, user.access_token)
      .then((response) => {
        // dataHandler(response.data);
        setData(response.data.rows);
        setTotalItems(response.data.pager.total_items);
        setIsLoading(false);
      })
      .catch((_error) => {
        console.log("content error: ", _error);
        if (_error.response) {
          _setError(true, _error.response.status, _error.response.statusText);
        } else if (_error.request) {
          _setError(true, 0, alertMessages.requestError.message);
        } else {
          _setError(true, 0, alertMessages.unkownError.message);
        }
      });
  };

  /**
   * @function onPaginate
   * @description Pagination callback
   * @param {int} _index - Page number
   */
  const onPaginate = (_index) => {
    setIsLoading(true);

    setCurrentPage(_index);
    getContent(_index);
  };

  // Pagination component
  const renderPagination = () => {
    if (totalItems <= pageSize) {
      return null;
    } else {
      return (
        <Pagination
          owner="client"
          containerClasses={`creator-pagination d-flex justify-content-center align-items-center mt-4`}
          previousDisabled={currentPage === 1 ? true : false}
          nextDisabled={data.length < pageSize ? true : false}
          currentPage={currentPage}
          onPrevious={() => {
            onPaginate(currentPage - 1);
          }}
          onNext={() => {
            onPaginate(currentPage + 1);
          }}
        />
      );
    }
  };

  const dataComponent = () => {
    if (typeof data !== "undefined" && data.length > 0) {
      return (
        <Row>
          {data.map((item, index) => {
            return (
              <React.Fragment key={`gallery-${index}`}>
                <GalleryItem
                  creator={true}
                  item={{
                    ...item,
                    is_share_enabled: true,
                    isViewEnabled: true,
                    creatorActionsEnabled: true,
                  }}
                  user={user}
                  contentType={contentType}
                />
              </React.Fragment>
            );
          })}
        </Row>
      );
    } else {
      return <NoData activeIndex={activeIndex} />;
    }
  };

  // Updates content counter
  const updateRemoteCounter = () => {
    const updateData = {
      contentType: "gallery",
      acknowledgedCount: counter?.contentCounts?.gallery || 0,
    };

    patchNode(`${serverUrl}/api/v2/counter`, updateData, user.csrf_token)
      .then((response) => {
        if (response.data) {
          dispatch({ type: "UPDATE_COUNTER", payload: response.data });
        }
      })
      .catch((error) => {
      });
  };

  return (
    <>
      {isError ? (
        <Error status={errorStatus} message={errorMessage} />
      ) : (
        <main className="galleries  screen">
          <PostContextProvider
            editRoute={"/galleries/edit"}
            previewRoute={"/galleries/preview"}
            viewRoute={"/galleries/view"}
            entityType={"gallery"}
          >
            <PageHeader
              pageName="Galleries Library"
              filters={true}
              owner="client"
              pageNameColor="clientHeadingScreens"
              svgLogo={clientTheme.pageLogos.svg}
              pageLogo={clientTheme.pageLogos.galleries}
              enableFavorites={favoritesEnabled}switchLink={`/galleries`}
              switchStatus={true}
              contentTypeName={"gallery"}
              createNew={true}
              handleCreate={() => {
                navigate(`/galleries/add`);
              }}
              hasSearch={true}
              nestedCategorySelector={true}
              searchEntityType="galleries"
              categories={categories}
              categoryTitle="Galleries"
              categoryName="galleries"
              getFavourites={() => {
                setActiveIndex(activeIndex === 0 ? 1 : 0);
                setIsLoading(true);
              }}
              activeTabIndex={activeIndex}
              postFilters={true}
              filterProps={{
                categories: categories,
                languages: languages,
                references: references,
                sitas: sitas,
                filterEntityType: "galleries",
                redux: true,
              }}
            />
            {isLoading ? (
              <CompanyappLoader />
            ) : (
              <>
                {dataComponent()}
                {renderPagination()}
              </>
            )}
            <PostPublishing
              publishPath={apiEndpoints.gallery}
              categories={categories}
              languages={languages}
              sitas={sitas}
              references={references}
              user={user}
              permissions={permissions}
              getContent={() => getContent(currentPage)}
            />
            <PostShare user={user} permissions={permissions} />
            <PostItemActions />
            <PostDelete
              deletePath={apiEndpoints.gallery}
              user={user}
              getContent={() => {
                setIsLoading(true);
                getContent(currentPage);
              }}
            />
            <PostSetting
              categories={categories}
              references={references}
              sitas={sitas}
              languages={languages}
              user={user}
              getContent={() => {
                setIsLoading(true);
                getContent(currentPage);
              }}
            />
          </PostContextProvider>
        </main>
      )}
    </>
  );
}
